import React, {useEffect} from 'react';
import {Grid} from "@material-ui/core";
import {Heading24, InputRow} from "../../components";
import {getUserDataFromLocalStorage, onChangeInput} from "../../services/utils";

function CheckoutForm(props) {
  const {state, setState} = props;
  const {values, errors} = state;
  let user = getUserDataFromLocalStorage()
  useEffect(() => {
    onChangeInput(user.firstName, 'firstName', state, setState)
    onChangeInput(user.lastName, 'lastName', state, setState)
    onChangeInput(user.mobileNumber, 'mobile', state, setState)
    onChangeInput(user.email, 'email', state, setState)
  }, [])
  return (
    <Grid item lg={6} md={5}>
      <Grid container direction='column' className='pr-20'>
        <Heading24 title={'buyer info'}/>
        <div className='mt-10'>
          <InputRow
            types={[
              {value: values.firstName, error: errors.firstName, label: 'first Name', id: "firstName"},
              {value: values.lastName, error: errors.lastName, label: 'last Name', id: "lastName"},
              {value: values.email, error: errors.email, label: 'email'},
              {value: values.mobile, error: errors.mobile, label: 'mobile'},
            ]}
            onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
            numOfInputPerRow={2}
          />
        </div>
        <div className='mt-10'>
          <InputRow
            types={[
              {value: values.address, error: errors.address, label: 'address', rows: 4, maxLength: 50},
            ]}
            onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
            numOfInputPerRow={1}
          />
        </div>

        <div className='mt-10'>
          <InputRow
            types={[
              {value: values.note, error: errors.note, label: 'note', rows: 4, required: false},
            ]}
            onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
            numOfInputPerRow={1}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default CheckoutForm;
